import styled from '@emotion/styled';
import { Text, TextLabel } from 'ds/components/typography';
import { typographyFontSizeCfg } from 'ds/components/typography/types';
import { colorToAlpha } from 'helpers/insight';
import { AgentImgSize } from '.';
import { Link } from 'components/link';

const Box = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const ImgSize = styled.div`
  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    transition: transform 0.1s ease-out, box-shadow 0.1s ease-out;
  }
`;

export const CardWrapper = styled(Box)`
  position: relative;
  gap: ${({ theme }) => theme.spacing(2)};
  .tooltip-wrapper {
  }
  ${({ theme }) => theme.media.showAt({ from: 3 })`
    :hover {
      .agent-logo {
        transform: scale(1.05);
      }
      .agent-logo-pagent {
        :before {
          opacity: 1;
        }
      }
    }
  `}
`;

export const ImgBGCover = styled.div`
  position: relative;
  svg {
    width: 100%;
    height: 100%;
  }
  :before {
    content: "";
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.2) 100%);
    z-index: 1;
    opacity: 0;
    transition: opacity 0.1s ease-out;
  }
`;

export const ImgWrapper = styled(ImgSize)<{ imgSize: number, size: AgentImgSize }>`
  ${({ theme, imgSize, size }) => `
    width: ${imgSize}px;
    height: ${imgSize}px;
    padding: ${theme.spacing(size === 'large' ? 2 : 1)};
    background-color: ${theme.colors.neutrals.white};
    border-radius: ${theme.borderRadius.round};
    border: 1px solid ${theme.colors.neutrals.grey8};
    overflow: hidden;
    > div {
      background-color: ${theme.colors.neutrals.grey11};
      border-radius: ${theme.borderRadius.round};
      overflow: hidden;
      width: 100%;
      height: 100%;
    }
  `}
`;

export const OfficeImg = styled(ImgSize.withComponent(Link))<{ imgSize: number; officeSize: number }>`
  overflow: hidden;
  border-radius: 4px;
  position: absolute;
  transform: translateX(-50%);
  text-decoration: none;
  left: 50%;
  z-index: 1;
  ${({ theme, officeSize, imgSize }) => `
    width: ${officeSize}px;
    height: ${officeSize}px;
    padding: ${theme.spacing(0.25)};
    box-shadow: 0 2px 5px 0 ${colorToAlpha(theme.colors.neutrals.black, 0.1)};
    background: ${theme.colors.neutrals.white};
    top: ${imgSize - officeSize + 10}px;
  `}
`;

export const TextWrapper = styled(Box)`
  gap: ${({ theme }) => theme.spacing(0.5)};
`;

export const Name = styled.div`
  font-weight: 700;
  font-size: ${typographyFontSizeCfg.h2.mobile}px;
  line-height: 28px;
  color: ${({ theme }) => theme.colors.neutrals.grey1};
  text-align: center;
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(0.25)};
`;

export const Title = styled(Text)`
  color: ${({ theme }) => theme.colors.neutrals.grey2};
  text-align: center;
`;

export const LeadingLabel = styled(Text)<{ disablePosition?: boolean }>(({ theme, disablePosition }) => ({
  color: theme.colors.brand.lighter,
  backgroundColor: theme.colors.brand.lightest,
  padding: theme.spacing(1, 2.5),
  borderRadius: theme.borderRadius.small,
  border: `1px solid ${colorToAlpha(theme.colors.brand.lighter, 0.2)}`,
  ...(disablePosition ? { } : {
    bottom: '-18px',
    position: 'absolute',
    zIndex: 12,
  }),
}));

export const MobLeadingLabel = styled(TextLabel.withComponent(LeadingLabel))(({ theme }) => ({
  color: theme.colors.brand.lighter,
  whiteSpace: 'nowrap',
  padding: theme.spacing(1, 0.5),
}));

export const LeadingOfficeAgentLabel = styled(Text)<{ top: number }>(({ theme, top }) => ({
  position: 'absolute',
  zIndex: 11,
  ...(top ? { top: `${top - 37}px` } : {}),
}));
